<template>
  <div>


    <a-card class="all-card-style ">

      <a-form-model ref="ModelForm" :rules="FormRules"  :model="model"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

        <a-form-model-item  prop="cCode" label="支管编号" class="ant-form-item2">
          <a-input v-model="model.cCode" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="cName" label="支管名称" class="ant-form-item2">
          <a-input v-model="model.cName" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item prop="cDeviceID" label="所属设备"  class="ant-form-item2">
          <a-select v-model="cDeviceID" @change="deviceIDSelect"   class="ant-form-item3"  >
            <a-select-option v-for="(item,index) in deviceIDSelectItems" :value="item.ID">
              {{item.DeviceAsName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item prop="cControllerID" label="所属执行器"  class="ant-form-item2">
          <a-select v-model="cControllerID" class="ant-form-item3"  >
            <a-select-option v-for="(item,index) in controllerIDSelectItems" :value="item.ID">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item  prop="cValvetypeName" label="阀门型号" class="ant-form-item2">
          <a-input v-model="model.cValvetypeName" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="cValvefirm" label="阀门厂商" class="ant-form-item2">
          <a-input v-model="model.cValvefirm" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fMaxflow" label="额定流量（m3/h）" class="ant-form-item2">
          <a-input v-model="model.fMaxflow" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fArea" label="面积（亩）" class="ant-form-item2">
          <a-input v-model="model.fArea" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="cZgTypeID"  label="支管类型" class="ant-form-item2">
          <a-select v-model="cZgTypeID"  class="ant-form-item3 "  >
            <a-select-option  value="PE">
              PE
            </a-select-option>

          </a-select>
        </a-form-model-item>
        <a-form-model-item  prop="fLong" label="支管长度（m）" class="ant-form-item2">
          <a-input v-model="model.fLong" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="iDiam" label="直径（mm）" class="ant-form-item2">
          <a-input v-model="model.iDiam" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fDropflow" label="滴头流量（m3）" class="ant-form-item2">
          <a-input v-model="model.fDropflow" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fDropdist" label="滴头间距（m）" class="ant-form-item2">
          <a-input v-model="model.fDropdist" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fDroplong" label="滴管长度（m）" class="ant-form-item2">
          <a-input v-model="model.fDroplong" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fDropirrdist" label="滴灌带间距（m）" class="ant-form-item2">
          <a-input v-model="model.fDropirrdist" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item prop="cPlatformID" label="所属项目"  class="ant-form-item2">
          <a-select v-model="model.cPlatformID" @change="platformSelect"  class="ant-form-item3">
            <a-select-option v-for="(item,index) in platformSelectItems" :value="item.ID">
              {{item.cPlatformName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cSceneID" label="所属场地"  class="ant-form-item2">
          <a-select v-model="model.cSceneID"  class="ant-form-item3"  >
            <a-select-option v-for="(item,index) in sceneformSelectItems" :value="item.ID">
              {{item.cSceneName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item  prop="cCropname" label="作物名称" class="ant-form-item2">
          <a-input v-model="model.cCropname" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="cLandtypeID"  label="土壤类型" class="ant-form-item2">
          <a-select v-model="cLandtypeID"  class="ant-form-item3 "  >
            <a-select-option  value="粘土">
              粘土
            </a-select-option>

          </a-select>
        </a-form-model-item>
        <a-form-model-item  prop="cLanddcap" label="土壤干容重" class="ant-form-item2">
          <a-input v-model="model.cLanddcap" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fLandhcap" label="田间持水量（m3）" class="ant-form-item2">
          <a-input v-model="model.fLandhcap" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item  prop="fLandwcap" label="凋萎含水量（m3）" class="ant-form-item2">
          <a-input v-model="model.fLandwcap" placeholder="请输入" :rows="3" />
        </a-form-model-item>





        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>


<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData,_getAllUser } from '@/common/request'

  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        uploadurl:"",
        cDeviceID:"",
        cControllerID:"",
        fileList:[],
        platformSelectItems:[],
        sceneformSelectItems:[],
        controllerIDSelectItems:[],
        cropNameSelectItems:[],
        farmingContentIDSelectItems :[],
        cropGrowthperiodSelectItems:[],
        userSelectItems:[],
        deviceIDSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        cZgTypeID:'',
        iTypeID:3,
        cLandtypeID:'',
        titleMsg1: "生产管理",
        titleMsg2:'工单管理',
        titleMsg3:'工单管理-新增',
        titleMsg4:'工单管理-新增',
        model:{},
        cEntID:"",
        FormRules:{
          cTitle:[
            { required: true, message: '请输入灌水名称', trigger: 'blur' }
          ],
          cCropID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cCropGrowthPeriodID:[
            { required: true, message: '请选择作物生长期', trigger: 'change' }
          ],

        /*  fArea:[
            { required: true, message: '请输入灌溉面积', trigger: 'blur' }
          ],*/
          dStartDate:[
            { required: true, message: '请选择开始时间', trigger: 'change' }
          ],
          dEndDate:[
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],

          fQuota:[
            { required: true, message: '请输入灌水定额', trigger: 'blur' }
          ],
          iNum:[
            { required: true, message: '请输入灌水次数', trigger: 'blur' }
          ],
        }
      }
    },
    mounted () {
      let that=this;

      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.model.cEntID=that.$store.getters.User.enterprise.ID;


      if (that.$route.params.ID){
        that.model.ID=that.$route.params.ID;
        that.HandleDetail();

      }
      else {
        that.iTypeID=that.$route.params.iTypeID

        that.model.cParentID=that.$route.params.cParentID;
      }
      that.model.cSceneID=that.$store.getters.SCene.ID;
      that.model.cSceneName=that.$store.getters.SCene.cSceneName;
      that.getEntPlatFormData()
      that.getAllUser();
      that.getCropNameData();
      that.getFarmingContentIDData();
      that.getWorkOrder();
      that.getCropGrowthperiodSelectItems();
      that.getDeviceIDSelectItems();
    },

    methods:{
      async getDeviceIDSelectItems(){
        let that=this;
        let res = await this.$http.post('WLWDevice/List', {
          cEntID:that.$store.getters.User.enterprise.ID,cSystemCode:'节水灌溉'
        });
        that.deviceIDSelectItems =res.data.obj.list;
      },
      onCropGrowthPeriodChange(item){

        this.model.CropGrowthPeriodName=this.cropGrowthperiodSelectItems.filter(s=>s.ID==item)[0].cDicName

      },
      onCropIDChange(item){
        this.model.cCropName=this.cropNameSelectItems.filter(s=>s.ID==item)[0].cDicName;
      },
      uploadchange(e){

        let that=this;

        if (e.file){

          that.fileList.push({
            uid:e.file.response.Id,
            name: e.file.response.Id,
            status: 'done',
            response: '', // custom error message to show
            url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id,
          })




        }

      },


      deviceIDSelect(){
        this.getPropertiesW();
      },
async getPropertiesW(){
let that=this;
let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+that.cDeviceID,{});
if(res.data.code=='200'){
  that.controllerIDSelectItems=res.data.obj.list;
  that.cControllerID= that.cControllerID;

  if(that.controllerIDSelectItems.length>0) {
  //  that.cControllerID=that.controllerIDSelectItems[0].ID

  }


}
  },
      platformSelect(){

        this.getSceneData()
      },
      async getAllUser(){

        let that=this
        let res=await _getAllUser(this,this.queryPlatformInfo);
        console.log(res);
        if(res.code=='200'){
          that.userSelectItems=res.obj.list
        }
      },
      async getWorkOrder(){
        var that=this
        let res=await that.$http.post('EntWorkOrderTask/List',{cSystemCode:'节水灌溉'
        })
        if(res.data.code=='200'){
          that.workOrderSelectItems=res.data.obj.list
        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.model.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.model.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.model.cSceneID=that.sceneformSelectItems[0].ID
            that.model.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getCropGrowthperiodSelectItems(){
        var that=this
        let param={dicClassCode: 'CropGrowthPeriod'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropGrowthperiodSelectItems=res.data.obj.list
        }
      },
      async getCropNameData(){
        var that=this
        let param={dicClassCode: 'CropName'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropNameSelectItems=res.data.obj.list
        }

      },
      async getFarmingContentIDData(){
        var that=this

        let param={dicClassCode: 'FarmingContent'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code='200'){
          that.farmingContentIDSelectItems=res.data.obj.list;
        }


        //  let res=await that.$http.post('FarmingContent/List',{});


      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      sceneformSelect(){
        let that=this;
        that.model.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.model.cSceneID)
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntWLWCropWaterPipe/FindById/' + that.model.ID, null)

        if (res.data.code == "200") {
          that.model = res.data.obj.data;
          that.iTypeID=that.model.iTypeID;
          that.cZgTypeID=that.model.cZgTypeID;
          that.cLandtypeID=that.model.cLandtypeID;


          that.cDeviceID=     that.model.cDeviceID;
          that.cControllerID=   that.model.cControllerID;
          that.getPropertiesW()
        } else {

        }
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['ModelForm'];
        form.validate(async valid => {



          that.model.cSystemCode='节水灌溉';
          that.model.cZgTypeID=  that.cZgTypeID;
          that.model.iTypeID=that.iTypeID;
          that.model.cLandtypeID=that.cLandtypeID;
          that.model.cDeviceID=that.cDeviceID;
          that.model.cControllerID=that.cControllerID;

          if (valid) {
            //url


            let res = await that.$http.post('EntWLWCropWaterPipe/Save', that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'EntWLWCropWaterPipeList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

